<template>
  <yn-modal>
    <span slot="title">Annotation Log</span>
    <yn-list
      v-if="Array.isArray(item.audit) && item.audit.length > 0"
      name="audit"
      :data="item.audit"
      :total="item.audit.length"
      :skip="0"
      :size="item.audit.length"
      :metadata="{
        by: {
          label: 'By',
          width: '1fr'
        },

        label: {
          label: 'Label',
          width: '75px'
        }
      }"
      :actions="[]"
      :is-request-pending="false"
      :is-request-failed="false"
    >
      <template v-slot:label="{ item }">
        <i v-if="item.complaint && item.complaint.length" class="task-report">
          ⚑
        </i>
        <span v-else>{{ !!item.label }}</span>
      </template>
    </yn-list>
    <div v-else>
      This item was not labeld yet.
    </div>
    <div slot="footer">
      <yn-button type="text" color="secondary" @click="close">Close</yn-button>
    </div>
  </yn-modal>
</template>

<script>
import Button from './../common/Button';
import Modal from './../common/Modal';
import List from './../common/List';

export default {
  components: {
    'yn-button': Button,
    'yn-modal': Modal,
    'yn-list': List
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      complaint: ''
    };
  },
  computed: {
    isValid() {
      return this.complaint && this.complaint.length && this.complaint.length < 256;
    }
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
.task-report {
  color: var(--theme-error);
  padding: 0 0.25rem;
  font-size: 1rem;
}
</style>
